import { useEffect } from 'react';
import equals from 'react-fast-compare';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { useSellerLabelProviders } from '../../../../../hooks/use-seller-label-providers';
import { getSellerLabelProviderBalances } from '../api';

const initialBalanceMap = {};

const useSellerLabelProviderBalanceMap = () => {
  const sellerLabelProviders = useSellerLabelProviders();
  const [balancesMap, setBalancesMap] = useAsyncSafeState(initialBalanceMap);
  const [loading, setIsLoading] = useAsyncSafeState(false);

  useEffect(() => {
    const load = async () => {
      try {
        setIsLoading(true);
        const balancesData = await getSellerLabelProviderBalances();
        const proposedBalancesMap = balancesData.reduce((acc, balance) => {
          return {
            ...acc,
            [balance.sellerLabelProviderId]: balance,
          };
        }, {});
        setBalancesMap((previousBalancesMap) => {
          return equals(previousBalancesMap, proposedBalancesMap) ? previousBalancesMap : proposedBalancesMap;
        });
      } catch {
        setBalancesMap(initialBalanceMap);
      } finally {
        setIsLoading(false);
      }
    };
    load();
  }, [sellerLabelProviders, setBalancesMap, setIsLoading]);

  return {
    balancesMap,
    loading,
  };
};

export default useSellerLabelProviderBalanceMap;
